import styled from 'styled-components';
import { CustomDialog } from '../../../../../../../../components/dialog/v1/CustomDialog';
import { returnExchangeDownloadFormVariables } from '../../../../../../variables/return-exchange-download-form-variables';
import CustomBlockButton from '../../../../../../../../components/button/CustomBlockButton';
import { useState } from 'react';
import { customToast } from '../../../../../../../../components/toast/custom-react-toastify/v1';

const StyledHeader = styled.div`
    padding: 10px;
`;

const StyledBody = styled.div`
    padding: 10px;

    .release-all-button{
        cursor: pointer;
        background-color: #efefef;
        color: #333;
        font-size: 12px;
        font-weight: 600;
        border: 1px solid #efefef;
        padding: 5px;
        border-radius: 3px;
        margin-bottom: 5px;
    }

    .mergeShipmentKeys{
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 5px;
        height: 200px;
        overflow-y: auto;
        border: 1px solid #e0e0e0;
        padding: 5px;
        border-radius: 3px;

        .mergeShipmentKeys-item{
            font-size: 10px;
            font-weight: 600;
            border: 1px solid #e0e0e0;
            padding: 5px;
            border-radius: 3px;
            cursor: pointer;

            &.selected{
                border-color: #333;
            }
        }
    }
    
    .preview-box{
        margin-top: 10px;
        .title{
            font-size: 12px;
            font-weight: 600;
            margin-bottom: 5px;
        }
        .items{
            display: flex;
            gap: 5px;
            flex-wrap: wrap;
            
            .item{
                font-size: 12px;
                font-weight: 600;
            }
        }

    }
`;

const StyledFooter = styled.div`
    padding: 10px;

    button{
        border-radius: 3px;
        border: none;
        background: #333;
        color: #fff;
        font-weight: 600;
    }
`;

export function ModalMergeShipmentKeys({
    open,
    onClose,
    mergeShipmentKeys,
    onConfirm
}) {
    const [currentSelectedKeys, setCurrentSelectedKeys] = useState(mergeShipmentKeys);

    const handleSelectKey = (key) => {
        if (currentSelectedKeys.includes(key)) {
            setCurrentSelectedKeys(currentSelectedKeys.filter(k => k !== key));
        }
        else {
            if (currentSelectedKeys?.length >= 5) {
                customToast.error('최대 5개까지 선택 가능합니다.');
                return;
            }
            setCurrentSelectedKeys([...currentSelectedKeys, key]);
        }
    }

    const handleReleaseAll = () => {
        setCurrentSelectedKeys([]);
    }

    const handleSubmit = () => {
        onConfirm(currentSelectedKeys);
        onClose()
    }
    return (
        <>
            <CustomDialog
                open={open}
                onClose={onClose}
            >
                <StyledHeader>
                    <CustomDialog.Header>
                        <CustomDialog.Header.Fake />
                        <CustomDialog.Header.Title>
                            합배송 조건 선택
                        </CustomDialog.Header.Title>
                        <CustomDialog.Header.Close onClick={onClose} />
                    </CustomDialog.Header>
                </StyledHeader>
                <StyledBody>
                    <button type='button' className='release-all-button' onClick={() => handleReleaseAll()}>전체해제</button>
                    <div className='mergeShipmentKeys'>
                        {returnExchangeDownloadFormVariables?.map(r => {
                            const isSelected = currentSelectedKeys.includes(r.fieldName);
                            return (
                                <div key={r.fieldName} className={`mergeShipmentKeys-item ${isSelected ? 'selected' : ''}`} onClick={() => handleSelectKey(r?.fieldName)}>{r.label}</div>
                            )
                        })}
                    </div>
                    <div className='preview-box'>
                        <div className='title'>선택됨</div>
                        <div className='items'>
                            {currentSelectedKeys.map(r => {
                                const downloadFormVariable = returnExchangeDownloadFormVariables.find(v => v.fieldName === r);
                                return (
                                    <div key={r} className='item'>"{downloadFormVariable?.label}"</div>
                                )
                            })}
                        </div>
                    </div>
                </StyledBody>
                <StyledFooter>
                    <CustomBlockButton
                        type='button'
                        onClick={() => handleSubmit()}
                    >
                        적용
                    </CustomBlockButton>
                </StyledFooter>
            </CustomDialog>
        </>
    );
}